export default {"src":"/_next/static/media/typescript.27df170d.svg","height":2500,"width":2500,"blurWidth":0,"blurHeight":0};